var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"fbdiv",staticClass:"fretboard",attrs:{"id":_vm.domId},on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }